import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import detector from "i18next-browser-languagedetector";

// Configuración básica para silenciar la advertencia de react-i18next
const resources = {
  es: {
    translation: {
      "Cerrar Sesión": "Cerrar Sesión"
    }
  }
};

i18n
  .use(detector)
  .use(initReactI18next) // inyecta i18n en react-i18next
  .init({
    resources,
    lng: "es",
    fallbackLng: "es",
    keySeparator: false,
    interpolation: {
      escapeValue: false // react ya protege contra xss
    }
  });

export default i18n;
